// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var ref = allVue.ref;
var inject = allVue.inject;
import { classNames } from '@progress/kendo-vue-common';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { messages, headerStatusUploading, headerStatusUploaded } from './messages';
/**
 * @hidden
 */

/**
 * Represents the default `UploadStatus` component.
 */

var UploadStatus = {
  props: {
    isUploading: Boolean,
    isUploaded: Boolean,
    isUploadFailed: Boolean
  },
  inject: {
    kendoLocalizationService: {
      default: null
    }
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    var kendoLocalizationService = inject('kendoLocalizationService', {});
    return {
      v3: v3,
      kendoLocalizationService: kendoLocalizationService
    };
  },
  render: function render(createElement) {
    var h = gh || createElement;
    var _a = this.$props,
        isUploading = _a.isUploading,
        isUploaded = _a.isUploaded,
        isUploadFailed = _a.isUploadFailed;
    var statusClassName = classNames(!isUploading && !isUploadFailed && isUploaded ? 'k-i-checkmark' : '', !isUploading && isUploadFailed ? 'k-i-exception' : '', isUploading ? 'k-i-loading' : '', 'k-icon');
    var statusText = '';
    var localizationService = provideLocalizationService(this);

    if (isUploading) {
      statusText = localizationService.toLanguageString(headerStatusUploading, messages[headerStatusUploading]);
    } else if (isUploaded || isUploadFailed) {
      statusText = localizationService.toLanguageString(headerStatusUploaded, messages[headerStatusUploaded]);
    }

    return h("div", {
      "class": classNames('k-upload-status', 'k-upload-status-total')
    }, [h("span", {
      "class": statusClassName
    }), statusText]);
  }
};
var UploadStatusVue3 = UploadStatus;
export { UploadStatus, UploadStatusVue3 };